var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import moment from 'moment-timezone';
import { useEffect, useState } from 'react';
import { getCurrentMedicationSettings, getCurrentStateTerritoryTermSettings } from '../Async/MedicationSettingsAsync';
import { useError } from '../Components/ErrorBoundary';
import { ApplicationStorageKeys, loadFromLocalStorage, saveToLocalStorage } from '../Shared/LocalStorage';
export var TimeUnits;
(function (TimeUnits) {
    TimeUnits["Days"] = "days";
    TimeUnits["Months"] = "months";
    TimeUnits["Hours"] = "hours";
    TimeUnits["Minutes"] = "minutes";
    TimeUnits["Seconds"] = "seconds";
})(TimeUnits || (TimeUnits = {}));
export function convertTimeUnitsToUnitOfTime(timeUnit) {
    switch (timeUnit) {
        case TimeUnits.Days:
            return 'days';
        case TimeUnits.Months:
            return 'months';
        case TimeUnits.Hours:
            return 'hours';
        case TimeUnits.Minutes:
            return 'minutes';
        case TimeUnits.Seconds:
            return 'seconds';
    }
    return 'minutes';
}
export function convertTimeOutToMilliSeconds(number, timeUnit) {
    switch (timeUnit) {
        case TimeUnits.Months:
            return Math.floor(number * 365 * 24 * 60 * 60 * 1000);
        case TimeUnits.Days:
            return Math.floor(number * 24 * 60 * 60 * 1000);
        case TimeUnits.Hours:
            return Math.floor(number * 60 * 60 * 1000);
        case TimeUnits.Minutes:
            return Math.floor(number * 60 * 1000);
        case TimeUnits.Seconds:
            return Math.floor(number * 1000);
        default:
            return 1500; //default timeout 15 milliseconds
    }
}
var medicationSettings;
var cachedStateTerritoryTermSettings;
export function getOnDemandMedicationSettings() {
    return __awaiter(this, void 0, void 0, function () {
        var newMedicationSettings, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!!medicationSettings) return [3 /*break*/, 4];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, getCurrentMedicationSettings()];
                case 2:
                    newMedicationSettings = _a.sent();
                    setMedicationSettings(newMedicationSettings);
                    return [2 /*return*/, newMedicationSettings];
                case 3:
                    err_1 = _a.sent();
                    throw Error('Unable to load medication settings');
                case 4: return [2 /*return*/, medicationSettings];
            }
        });
    });
}
function getOnDemandStateTerritoryTermSettings() {
    return __awaiter(this, void 0, void 0, function () {
        var newStateTerritoryTermSettings, err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!!cachedStateTerritoryTermSettings) return [3 /*break*/, 4];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, getCurrentStateTerritoryTermSettings()];
                case 2:
                    newStateTerritoryTermSettings = _a.sent();
                    cacheStateTerritoryTermSettings(newStateTerritoryTermSettings);
                    return [2 /*return*/, newStateTerritoryTermSettings];
                case 3:
                    err_2 = _a.sent();
                    throw Error('Unable to load state territory settings');
                case 4: return [2 /*return*/, cachedStateTerritoryTermSettings];
            }
        });
    });
}
export var SettingsStatus;
(function (SettingsStatus) {
    SettingsStatus[SettingsStatus["Init"] = 0] = "Init";
    SettingsStatus[SettingsStatus["Loading"] = 1] = "Loading";
    SettingsStatus[SettingsStatus["Loaded"] = 2] = "Loaded";
})(SettingsStatus || (SettingsStatus = {}));
export function useMedicationSettings() {
    var _this = this;
    var showError = useError();
    var _a = __read(useState(SettingsStatus.Init), 2), status = _a[0], setStatus = _a[1];
    var _b = __read(useState(loadFromLocalStorage(ApplicationStorageKeys.MedicationSettings, {
        genericPrescribingOnly: false,
        alwaysCreatePharmacyRequest: false,
        pharmacyRequestExpiryRequired: false,
        providersAreLinkedToUserAccounts: true,
        allowFreeTextMedication: false,
        enabledEditingExpiryDateAfterFinalised: false,
        defaultPharmacyRequestLength: {
            number: 4,
            timeUnits: TimeUnits.Months
        },
        reloginChallengeGracePeriod: {
            number: 10,
            timeUnits: TimeUnits.Minutes
        },
        maximumPharmacyRequestLength: {
            number: 4,
            timeUnits: TimeUnits.Months
        },
        scriptExchangeTimeout: {
            number: 15,
            timeUnits: TimeUnits.Seconds
        },
        encounterPlaceTerm: {
            abbreviatedPluralTerm: 'Places',
            abbreviatedSingularTerm: 'Place',
            pluralTerm: 'Encounter places',
            singularTerm: 'Encounter place'
        },
        pharmacyRequestTerm: {
            abbreviatedPluralTerm: 'Requests',
            abbreviatedSingularTerm: 'Request',
            pluralTerm: 'Pharmacy requests',
            singularTerm: 'Pharmacy request'
        },
        approvalNumberTerm: {
            abbreviatedPluralTerm: 'Approval numbers',
            abbreviatedSingularTerm: 'Approval number',
            pluralTerm: 'Approval numbers',
            singularTerm: 'Approval number'
        },
        authorityNumberTerm: {
            abbreviatedPluralTerm: 'Authority numbers',
            abbreviatedSingularTerm: 'Authority number',
            pluralTerm: 'Authority numbers',
            singularTerm: 'Authority number'
        },
        decisionSupportSettings: {
            prescriptionMonitoringEnabled: true,
            medicationToAllergiesEnabled: false,
            medicationToConditionEnabled: false,
            medicationToMedicationEnabled: false,
            medicationToPregnancyEnabled: false,
            decisionSupportWarningDescription: '',
            decisionSupportWarningTitle: '',
            showDecisionSupportWarning: false,
            decisionSupportWarningDisclaimer: ''
        },
        sendScriptRequestsToScriptExchange: true,
        sendPharmacyRequestsToScriptExchange: false,
        hideViewingRights: false,
        hideProblems: false,
        verbalOrderTerm: {
            abbreviatedPluralTerm: 'VOs',
            abbreviatedSingularTerm: 'VO',
            pluralTerm: 'Verbal orders',
            singularTerm: 'Verbal order'
        },
        enableFreeTextWitness: false,
        enableSupportiveDocumentation: false,
        modalMedications: false,
        defaultS8Duration: {
            number: 0,
            timeUnits: TimeUnits.Days
        },
        defaultShortCourseDuration: {
            number: 0,
            timeUnits: TimeUnits.Days
        },
        requestEmail: "editor@medicaldirector.com"
    })), 2), settings = _b[0], setSettings = _b[1];
    var _c = __read(useState(loadFromLocalStorage(ApplicationStorageKeys.StateTerritoryTermSettings, [])), 2), stateTerritoryTermSettings = _c[0], setStateTerritoryTermSettings = _c[1];
    var loadSettings = function () { return __awaiter(_this, void 0, void 0, function () {
        var newSettings, newStateTerritoryTermSettings, err_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setStatus(SettingsStatus.Loading);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, getOnDemandMedicationSettings()];
                case 2:
                    newSettings = _a.sent();
                    setSettings(newSettings);
                    saveToLocalStorage(ApplicationStorageKeys.MedicationSettings, newSettings);
                    return [4 /*yield*/, getOnDemandStateTerritoryTermSettings()];
                case 3:
                    newStateTerritoryTermSettings = _a.sent();
                    setStateTerritoryTermSettings(newStateTerritoryTermSettings);
                    saveToLocalStorage(ApplicationStorageKeys.StateTerritoryTermSettings, newStateTerritoryTermSettings);
                    setStatus(SettingsStatus.Loaded);
                    return [3 /*break*/, 5];
                case 4:
                    err_3 = _a.sent();
                    showError(err_3);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        loadSettings();
    }, []);
    var getTermFromState = function (stateCode) {
        var defaultTerm = 'Controlled substance reference';
        if (!stateCode)
            return defaultTerm;
        for (var index in stateTerritoryTermSettings) {
            var stateTerm = stateTerritoryTermSettings[index];
            if (stateTerm.stateCode.toLowerCase() === (stateCode === null || stateCode === void 0 ? void 0 : stateCode.toLowerCase())) {
                return stateTerm.jurisdictionalControlledSubstanceReferenceTerm.singularTerm;
            }
        }
        return defaultTerm;
    };
    var getDefaultDurationAsMoment = function () {
        var _a, _b, _c, _d;
        return moment().add((_b = (_a = settings.defaultPharmacyRequestLength) === null || _a === void 0 ? void 0 : _a.number) !== null && _b !== void 0 ? _b : 4, (_d = (_c = settings.defaultPharmacyRequestLength) === null || _c === void 0 ? void 0 : _c.timeUnits) !== null && _d !== void 0 ? _d : TimeUnits.Months);
    };
    var getS8DurationAsMoment = function () {
        var _a, _b, _c, _d;
        return ((_a = settings.defaultS8Duration) === null || _a === void 0 ? void 0 : _a.number) !== null
            ? moment().add((_b = settings.defaultS8Duration) === null || _b === void 0 ? void 0 : _b.number, (_d = (_c = settings.defaultS8Duration) === null || _c === void 0 ? void 0 : _c.timeUnits) !== null && _d !== void 0 ? _d : TimeUnits.Days)
            : null;
    };
    var getShortCourseDurationAsMoment = function () {
        var _a, _b, _c, _d;
        return ((_a = settings.defaultShortCourseDuration) === null || _a === void 0 ? void 0 : _a.number) !== null
            ? moment().add((_b = settings.defaultShortCourseDuration) === null || _b === void 0 ? void 0 : _b.number, (_d = (_c = settings.defaultShortCourseDuration) === null || _c === void 0 ? void 0 : _c.timeUnits) !== null && _d !== void 0 ? _d : TimeUnits.Days)
            : null;
    };
    return {
        status: status,
        settings: settings,
        getTermFromState: getTermFromState,
        getDefaultDurationAsMoment: getDefaultDurationAsMoment,
        getS8DurationAsMoment: getS8DurationAsMoment,
        getShortCourseDurationAsMoment: getShortCourseDurationAsMoment
    };
}
export function setMedicationSettings(newMedicationSettings) {
    medicationSettings = newMedicationSettings;
}
function cacheStateTerritoryTermSettings(newStateTerritoryTermSettings) {
    cachedStateTerritoryTermSettings = newStateTerritoryTermSettings;
}
